import { useCallback, useState } from 'react'
import { SESSAO_INICIAL, SessaoAtendimento, SessaoDaTela } from './core/_models'
import { useSessaoAtendimentoContexto } from './SessaoAtendimentoProvider'

/**
 * Mesma interface nos dois modos, para a tela não ter `if` espalhado: na rota do profissional
 * (`persistente`) usa a sessão compartilhada; nas demais, estado local como hoje.
 */
export const useSessaoAtendimento = (atendimentoId: number, persistente: boolean): SessaoDaTela => {
  const contexto = useSessaoAtendimentoContexto()
  const [local, setLocal] = useState<SessaoAtendimento>(SESSAO_INICIAL)

  const compartilhada =
    persistente && contexto !== undefined && contexto.podeUsarSessao(atendimentoId)
  const sessao = compartilhada ? contexto?.obterSessao(atendimentoId) ?? SESSAO_INICIAL : local

  const atualizar = useCallback(
    (parcial: Partial<SessaoAtendimento>) => {
      if (compartilhada && contexto) {
        contexto.atualizarSessao(atendimentoId, parcial)
        return
      }
      setLocal((atual) => ({ ...atual, ...parcial }))
    },
    [compartilhada, contexto, atendimentoId]
  )

  return { ...sessao, atualizar }
}
